import { render, staticRenderFns } from "./TrailerProfileTab.vue?vue&type=template&id=5648de48&scoped=true"
import script from "./TrailerProfileTab.vue?vue&type=script&lang=js"
export * from "./TrailerProfileTab.vue?vue&type=script&lang=js"
import style0 from "./TrailerProfileTab.vue?vue&type=style&index=0&id=5648de48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5648de48",
  null
  
)

export default component.exports